// src/subscreens/admin/deleteCategoryConfirmation/DeleteCategoryConfirmation.jsx

import React from "react";
import Modal from "../../../components/admin/modal/ProductModel";
import { AlertTriangle } from "lucide-react";
import "../../../assets/css/admin/deleteCategoryConfirmation/DeleteCategoryConfirmation.css";

const DeleteCategoryConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  categoryName,
  isDeleting = false,
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Category"
      size="small"
    >
      <div className="cat-del-content">
        <div className="cat-del-icon-wrapper">
          <AlertTriangle size={48} className="cat-del-icon" />
        </div>

        <div className="cat-del-message">
          <h3>Are you sure?</h3>
          <p>
            Do you really want to delete <strong>"{categoryName}"</strong>?
            <br />
            This action cannot be undone.
          </p>
        </div>

        <div className="cat-del-actions">
          <button
            className="cat-del-cancel-btn"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="cat-del-delete-btn"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteCategoryConfirmation;
